import {LiveImage} from "../image";
import {AContent} from "./base.content";
import {GalleryContent} from "./content/gallery.content";
import {ListContent} from "./content/list.content";
import {ImageListContent} from "./content/image-list.content";
import {HeaderOneContent} from "./headers/header-one.content";
import {BaseListImage} from "./content/base.content";
import {DetailsContent} from "./content/details.content";

function savedFilter(image: BaseListImage): boolean { return !image.isSaved;}

export function grabImages(items: AContent[]): BaseListImage[] {
  return items.reduce((previousValue: BaseListImage[], contentItem: GalleryContent|ListContent|ImageListContent|AContent) => {
    if (contentItem instanceof HeaderOneContent || contentItem instanceof DetailsContent) {
      return previousValue.concat(
        grabImages(contentItem.items.toArray())
      );
    } else if (contentItem instanceof GalleryContent) {

      return previousValue.concat(
        contentItem.items
          .toArray()
          .filter(savedFilter)
      );
    } else if (contentItem instanceof ListContent || contentItem instanceof ImageListContent) {
      return previousValue.concat(
        contentItem.items.toArray()
          .map(listItem => listItem.avatar)
          .filter(savedFilter),
        contentItem.items.toArray()
          .reduce((listPrev, listItem) => listPrev.concat(grabImages(listItem.details.items.toArray())), [])
      );
    } else {
     return previousValue;
    }
  }, []);
}



// WEBPACK FOOTER //
// ./src/api/club-cms/image-graber.ts